import { createFileRoute } from "@tanstack/react-router"
import { ApplicationShell } from "@/components/app/application-shell"

export const Route = createFileRoute("/app")({
  head: () => ({
    meta: [
      { title: "Workspace — intoshort" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: ApplicationShell,
})
